import type {
  ActionLabelContext,
  ActionPresentation,
  ResolvedObjectAction,
} from "@/object-actions/types";
import { getActionIcon, getActionLabel } from "@/object-actions/utils";
import type { ContextMenuAction } from "@cohesive/ui-components";
import { createElement } from "react";

export function resolvedActionsToContextMenuActions(
  actions: ResolvedObjectAction[],
  presentations: ActionPresentation[],
  labelCtx: ActionLabelContext,
): ContextMenuAction[] {
  return actions
    .filter((action) => presentations.includes(action.presentation))
    .map((action) => {
      const Icon = getActionIcon(action.definition, labelCtx);
      const label = getActionLabel(action.definition, labelCtx);

      if (action.variants && action.variants.length > 1) {
        return {
          key: action.id,
          label,
          icon: createElement(Icon, { className: "h-[17px] w-[17px]" }),
          disabled: action.disabled,
          destructive: action.definition.destructive,
          onClick: () => {},
          dropdownItems: action.variants.map((variant) => ({
            key: variant.id,
            label: variant.label,
            onClick: () => window.setTimeout(() => variant.handler(), 0),
          })),
        };
      }

      return {
        key: action.id,
        label,
        icon: createElement(Icon, { className: "h-[17px] w-[17px]" }),
        disabled: action.disabled,
        destructive: action.definition.destructive,
        onClick: () => window.setTimeout(() => action.handler(), 0),
      };
    });
}
